"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ldflex = require("ldflex");

var _SubjectPathResolver = _interopRequireDefault(require("./SubjectPathResolver"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SourcePathHandler =
/*#__PURE__*/
function () {
  function SourcePathHandler(pathFactory) {
    _classCallCheck(this, SourcePathHandler);

    this._paths = pathFactory;
  }

  _createClass(SourcePathHandler, [{
    key: "handle",
    value: function handle() {
      var _this = this;

      return function (source) {
        return _this._createSourcePathFactory(source);
      };
    }
  }, {
    key: "_createSourcePathFactory",
    value: function _createSourcePathFactory(source) {
      return new _ldflex.PathFactory({
        handlers: _objectSpread({}, _ldflex.defaultHandlers),
        resolvers: [new _SubjectPathResolver.default(this._paths, source)]
      }).create();
    }
  }]);

  return SourcePathHandler;
}();

exports.default = SourcePathHandler;